import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  upperSection: {
    backgroundColor: theme.palette.cinnamon.main,
  },
});
